import { useCallback } from 'react';
import { BudgetStatusEnum } from '../../../../enums/budgetStatus';
import { BudgetRecipientEnum } from '../../createAndEdit/types';
import { Budget } from '../../types';

interface IUseBudgetNavigationParams {
  budget: Budget;
  userProfile?: BudgetRecipientEnum | string;
  onViewBudget?: (budgetId: string, versionNumber?: number) => void;
  onEditBudget?: (budgetId: string, versionNumber?: number) => void;
  versionNumber?: number;
}

export const useBudgetNavigation = (params: IUseBudgetNavigationParams) => {
  const { budget, userProfile, onViewBudget, onEditBudget, versionNumber } = params;

  const handleBudgetClick = useCallback(() => {

    const currentVersion = versionNumber || budget.version;
    const lastVersion = budget.lastVersionNumber || currentVersion;
    const isLastVersion = currentVersion === lastVersion;
    const status = budget.status;
    const recipient = budget.recipient as BudgetRecipientEnum | string;

    const isApprovedByManager = status === BudgetStatusEnum.APPROVED || status === 'Aprovado';
    const shouldView = isApprovedByManager || !isLastVersion;

    if (shouldView) {
      onViewBudget?.(budget.id, currentVersion);
      return;
    }

    if (recipient === BudgetRecipientEnum.MANAGER || recipient === 'MANAGER') {
      onViewBudget?.(budget.id, currentVersion);
      return;
    }

    if (
      recipient === BudgetRecipientEnum.CONSULTANT || recipient === 'CONSULTANT' ||
      recipient === BudgetRecipientEnum.TOWER || recipient === 'FACTORY' || recipient === 'TOWER'
    ) {
      const recipientStr = String(recipient);
      const userProfileStr = userProfile ? String(userProfile) : '';
      
      const normalizedRecipient = 
        recipientStr === 'FACTORY' || recipientStr === 'TOWER' || recipientStr === BudgetRecipientEnum.TOWER
          ? BudgetRecipientEnum.TOWER
          : recipientStr === 'CONSULTANT' || recipientStr === BudgetRecipientEnum.CONSULTANT
          ? BudgetRecipientEnum.CONSULTANT
          : recipientStr;
      
      const normalizedUserProfile = 
        userProfileStr === 'FACTORY' || userProfileStr === 'TOWER' || userProfileStr === BudgetRecipientEnum.TOWER
          ? BudgetRecipientEnum.TOWER
          : userProfileStr === 'CONSULTANT' || userProfileStr === BudgetRecipientEnum.CONSULTANT
          ? BudgetRecipientEnum.CONSULTANT
          : userProfileStr;
      
      if (normalizedRecipient !== normalizedUserProfile) {
        onViewBudget?.(budget.id, currentVersion);
        return;
      }

      onEditBudget?.(budget.id, currentVersion);
      return;
    }

    onViewBudget?.(budget.id, currentVersion);
  }, [budget, userProfile, onViewBudget, onEditBudget, versionNumber]);

  return {
    handleBudgetClick,
  };
};

